import "./App.css";
import { useState } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import Dashboard from "./Pages/account/Dashboard";
import Login from "./Pages/account/Login";
import ForgetPassword from "./Pages/account/ForgetPassword";
import Header from "./components/ui/Header";
import Footer from "./components/ui/Footer";

import ForgetPasswordOtp from "./Pages/account/ForgetPasswordOtp";
import NewPassword from "./Pages/account/ForgetPasswordNewPassword";
// Master
import MasterSegment from "./Pages/master/segment/MasterSegment";
import MasterBank from "./Pages/master/bank/MasterBank";
import MasterBroker from "./Pages/master/broker/MasterBroker";
import MasterFinyear from "./Pages/master/finyear/MasterFinyear";
import MasterIndustry from "./Pages/master/industy/MasterIndustry";
import MasterRole from "./Pages/master/role/MasterRole";
import MasterPincode from "./Pages/master/pincode/MasterPincode";
import MasterSecurity from "./Pages/master/security/MasterSecurity";
import MasterScript from "./Pages/master/script/MasterScript";
import MasterDepository from "./Pages/master/depository/MasterDepository";
import MasterCoupon from "./Pages/master/coupon/MasterCoupon";
import MasterPrice from "./Pages/master/pricing/MasterPrice";
import AssignPermission from "./Pages/backoffice/accessAndPermission/AssignPermission";
import CorporateActionMaster from "./Pages/corpaction/corpActionMaster/CorporateActionMaster";
import MasterLedger from "./Pages/master/ledger/MasterLedger";
import ChangePassword from "./Pages/account/ChangePassword";
import PageNotFound from "./components/ui/404";
import Register from "./Pages/account/Register";
import Bhav from "./Pages/import/bhav/Bhav";
import Indices from "./Pages/import/indices/Indices";
import IndustryScrip from "./Pages/import/industryScrip/IndustryScrip";
import CorporateAction from "./Pages/import/corporateAction/CorporateAction";
import { useEffect } from "react";
import MFNav from "./Pages/import/mfNav/MFNav";
import MutualFund from "./Pages/import/mutualfund/MutualFund";
import SettlementCalendar from "./Pages/master/settlementCalendar/SettlementCalendar";
import MasterMF from "./Pages/master/mutualfund/MasterMF";
import TemplateBroker from "./Pages/backoffice/templateBroker/TemplateBroker";
import TemplatePMS from "./Pages/backoffice/templatePms/TemplatePMS";
import PMS from "./Pages/master/pms/PMS";
import SyncMaster from "./Pages/backoffice/syncMaster/SyncMaster";

function App() {
  const [encodedUrl, setEncodedUrl] = useState("");
  const [isReferral, setIsReferral] = useState("loading");
  const [referral, setReferral] = useState();
  const [leadData, setLeadData] = useState();

  const navigate = useNavigate();

  useEffect(() => {
    const url = new URL(window.location.href);

    // Get the pathname from the URL
    const pathname = url.pathname;
    // Remove the leading slash
    const encodedToken = pathname.substring(1);

    if (encodedToken) {
      try {
        const decoded = atob(encodedToken);
        if (decoded?.split("/")[1] === "setpassword") {
          setEncodedUrl(pathname);
        }
      } catch (error) {
        console.error("Failed to decode base64 string:", error);
      }
    }
  }, []);

  const permissions = JSON.parse(
    sessionStorage.getItem("SubscriberPermissions"),
  )
    ? JSON.parse(sessionStorage.getItem("SubscriberPermissions"))
    : JSON.parse(sessionStorage.getItem("Permissions"));

  const rawConfigs = {};
  permissions?.forEach((item) => {
    const menuName = item?.menu_name?.toLowerCase();
    if (!rawConfigs[menuName]) {
      rawConfigs[menuName] = [];
    }
    rawConfigs[menuName].push({
      name: item?.submenu_name,
      value: item?.submenu_name?.toLowerCase()?.replace(/\s+/g, "-"),
      url: item?.url,
    });
  });

  const findUrl = (menu, submenu) => {
    const url = rawConfigs?.[menu]?.find((item) => item.name === submenu);
    return url?.url;
  };

  function getElementForUrl(url) {


    switch (url) {
      //IMPORT
      case findUrl("import", "Bhav"):
        return <Bhav />;
      case findUrl("import", "Indices"):
        return <Indices />;
      case findUrl("import", "Scrip & Industry"):
        return <IndustryScrip />;
      case findUrl("import", "Corporate Action"):
        return <CorporateAction />;
      case findUrl("import", "Mutual Fund NAV"):
        return <MFNav />;
      case findUrl("import", "Mutual Fund"):
        return <MutualFund />;

      //BACK OFFICE
      case findUrl("back office", "Access & Permissions"):
        return <AssignPermission />;
      case findUrl("back office", "Template Mapping"):
        return <TemplateBroker />;
      case findUrl("back office", "PMS Template Mapping"):
        return <TemplatePMS />;
      case findUrl("back office", "Sync Master"):
        return <SyncMaster />;


      //MASTER
      case findUrl("masters", "Bank"):
        return <MasterBank />;
      case findUrl("masters", "Broker"):
        return <MasterBroker />;
      case findUrl("masters", "Corporate Action"):
        return <CorporateActionMaster />;
      case findUrl("masters", "Coupon"):
        return <MasterCoupon />;
      case findUrl("masters", "Depository"):
        return <MasterDepository />;
      case findUrl("masters", "Financial Year"):
        return <MasterFinyear />;
      case findUrl("masters", "Industry"):
        return <MasterIndustry />;
      case findUrl("masters", "Ledger"):
        return <MasterLedger />;
      case findUrl("masters", "Pin Code"):
        return <MasterPincode />;
      case findUrl("masters", "Pricing"):
        return <MasterPrice />;
      case findUrl("masters", "Role"):
        return <MasterRole />;
      case findUrl("masters", "Scrip"):
        return <MasterScript />;
      case findUrl("masters", "Security Type"):
        return <MasterSecurity />;
      case findUrl("masters", "Segment"):
        return <MasterSegment />;
      case findUrl("masters", "Settlement Calendar"):
        return <SettlementCalendar />;
      case findUrl("masters", "Mutual Fund"):
        return <MasterMF />;
      case findUrl("masters", "PMS"):
        return <PMS />;
      //LOGGED USER
      case findUrl("logged user", "Change Password"):
        return <ChangePassword />;
      case findUrl("logged user", "Dashboard"):
        return <Dashboard />;
      case findUrl("logged user", "Register"):
        return <Register />;
      // DEFAULT
      default:
        return <PageNotFound />;
    }
  }

  return (
    <div className="app">
      <Header permissions={permissions} isReferral={isReferral} />
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forget-password" element={<ForgetPassword />} />
        <Route path="/forget-password-otp" element={<ForgetPasswordOtp />} />
        <Route path="/forget-password-newpassword" element={<NewPassword />} />

        {/* IMPORT */}
        {rawConfigs["import"]?.map((item) => (
          <Route
            key={item.url}
            path={item.url}
            element={getElementForUrl(item.url)}
          />
        ))}

        {/* BACK OFFICE */}
        {rawConfigs["back office"]?.map((item) => (
          <Route
            key={item.url}
            path={item.url}
            element={getElementForUrl(item.url)}
          />
        ))}

        {/* MASTERS */}
        {rawConfigs["masters"]?.map((item) => (
          <Route
            key={item.url}
            path={item.url}
            element={getElementForUrl(item.url)}
          />
        ))}

        {/* LOGGED USER */}
        {rawConfigs["logged user"]?.map((item) => (
          <Route
            key={item.url}
            path={item.url}
            element={getElementForUrl(item.url)}
          />
        ))}
        <Route path="*" element={<PageNotFound />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
